<div class="header">
  <div class="image-wrapper">
    <img src="/assets/icons/notification/{{ notification.IconName }}" alt="" class="image" />
  </div>
  <div class="agreement-details-container">
    <h3 class="header__name">{{ notification.Title }}</h3>
    <span class="header__details_row">
      <span class="name"> {{ 'Wysłano' | translate }}: </span>{{ notification.Date | date : 'yyyy-MM-dd' }}
    </span>
  </div>
</div>
<div class="content" [innerHtml]="notification.Message | safeHtml"></div>
<div class="footer">
  <button mat-raised-button color="primary" mat-dialog-close>{{ 'settlement-details.close' | translate }}</button>
</div>
